import { ActionTypes } from "@/App/constants/actionTypes";

type DownloadManualClaim = {
  type: typeof ActionTypes.DOWNLOAD_BATCH_TRANSMISSION_MANUAL_CLAIM;
  payload: string;
};

export const downloadManualClaim = (id: string): DownloadManualClaim => {
  return {
    type: ActionTypes.DOWNLOAD_BATCH_TRANSMISSION_MANUAL_CLAIM,
    payload: id,
  };
};

export type DownloadBatchManualClaimActions = DownloadManualClaim;
